import { resourceExplorerGranularViewResponseSelector } from "./resourceExplorerGranularViewResponseSelector";
import { RootState } from "../../../../../store";
import { ResourceExplorerGranularCost } from "../../../../../../services/cloudchipr.api";

export const resourceExplorerGranularDataSelector = (
  state: RootState,
): undefined | ResourceExplorerGranularCost => {
  return resourceExplorerGranularViewResponseSelector(state)?.data;
};
